<div class="image-container">
    <sp-blurhash-placeholder
        *ngIf="image.blurHash"
        [blurHash]="image.blurHash"
        [width]="100"
        [height]="100"
        [punch]="1"
    ></sp-blurhash-placeholder>
    <img
        [src]="image.urls[size]"
        [alt]="image.description"
        (click)="imageClick.emit(image)"
        (load)="isLoaded = true"
        [class.img-loaded]="isLoaded"
    />
</div>
<div class="image-info">
    <a [href]="image.authorUrl + IMAGE_UTMS" target="_blank">{{ image.authorName }}</a>
    <p class="text-muted">{{ image.width }} x {{ image.height }} px</p>
</div>
